// extracted by mini-css-extract-plugin
export default {"wrapper":"ComingSoon_wrapper__rPMHJ"};